module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination",
    class: _vm.size ? 'pagination--' + _vm.size : ''
  }, [_c('li', {
    staticClass: "pagination__item pagination__item--previous",
    class: {
      'pagination__item--disabled': _vm.current$ === 1
    }
  }, [_c('span', {
    staticClass: "pagination__item-link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onPrevSpanClick()
      }
    }
  })]), _vm._v(" "), (_vm.simple === false) ? _vm._l((_vm.pagination), function(page, index) {
    return _c('li', {
      key: 't-pager-' + index,
      staticClass: "pagination__item",
      class: [{
          'pagination__item--active': page > 0 && _vm.current$ === page
        },
        {
          'pagination__item--jump': page < 0
        }
      ],
      on: {
        "mouseenter": function($event) {
          _vm.quickIconDirect = page
        },
        "mouseleave": function($event) {
          _vm.quickIconDirect = ''
        }
      }
    }, [(page < 0) ? _c('a', {
      staticClass: "pagination__item-link",
      class: [{
        'pagination__item-link-prev': _vm.quickIconDirect === -1 && page === -1
      }, {
        'pagination__item-link-next': _vm.quickIconDirect === -2 && page === -2
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$_onJumpPage(page)
        }
      }
    }) : _c('a', {
      staticClass: "pagination__item-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$_onAClick(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pagination__item pagination__item--next",
    class: {
      'pagination__item--disabled': _vm.current$ === _vm.amount
    }
  }, [_c('a', {
    staticClass: "pagination__item-link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onNextAClick()
      }
    }
  })]), _vm._v(" "), (_vm.hasOption) ? _c('li', {
    staticClass: "pagination__options"
  }, [(_vm.showSizer) ? _c('sizer', {
    attrs: {
      "page-size": _vm.pageSize$,
      "range": _vm.sizerRange$
    },
    on: {
      "on-change": _vm.$_onSizerChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showElevator) ? _c('elevator', {
    ref: "elevator",
    attrs: {
      "current": _vm.current$
    },
    on: {
      "on-change": _vm.$_onAClick
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a91b91c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pager/pager.vue
// module id = 394
// module chunks = 0